export default __webpack_public_path__ + "static/xch_landing-0c852776c85c16837b1138c04313beab.png";